<template>
	<div class="checkout-button">
		<PayCreditCardButton v-show="payingWithCreditCard" />
		<PaypalButton v-show="payingWithPaypal" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import PaypalButton from '@component/user-backend/Checkout/V4/paypal/PaypalButton.vue';
import PayCreditCardButton from '@component/user-backend/Checkout/V4/PayCreditCardButton.vue';

export default {
	components: { PayCreditCardButton, PaypalButton },

	computed: mapGetters('checkout', [
		'payingWithCreditCard',
		'payingWithPaypal',
	]),
};
</script>

<style scoped lang="scss">
.checkout-button {
	margin-bottom: 64px;

	&__button {
		height: var(--custom-control-height);
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: var(--size-sm);
	}
}
</style>
